$(document)
	.ready(function () {

		$('.inUse__gallery-list').owlCarousel({
			margin: 45,
			responsive: {
				0 :{
					margin: 15,
					items: 1
				},
				768 :{
					margin: 45,
					items: 2
				}
			}
		});
	})
	

	.on(`click`, `.inUse .inUse__wrap--grid-thumbnails-item`, function (e) {
		try {
			e.stopImmediatePropagation();
			const getImgSrc = $(this).find(`img`).attr(`large-img`);

			if (typeof getImgSrc !== "undefined" && getImgSrc) {
				$(this)
					.closest(`.inUse__wrap--grid-thumbnails`)
					.find(`.inUse__wrap--grid-thumbnails-item`)
					.removeClass(`selected`);

				$(this)
					.addClass(`selected`)
					.closest(`.inUse`)
					.find(`.inUse__wrap--grid-mainImg .inUse__wrap--grid-mainImg-imgWrap img`)
					.attr(`src`, getImgSrc);
			}
		} catch (err) {
			console.log(`ERROR .inUse__wrap--grid-thumbnails-item`, err.message);
		}
	});

	$(document).on('click', '.inUse__button > a', function(e) {
		e.preventDefault();
		$(this).closest('.inUse__button').toggleClass('active');
	})
